import { useEffect, useRef, useState } from "react";
import { useLanguage } from "@/lib/i18n";

const SearchableSelect = ({
  options,
  value,
  onChange,
  placeholder,
  testId,
  pinnedOptions = [],
}) => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const filtered = [
    ...options.filter((o) => o.toLowerCase().includes(query.trim().toLowerCase())),
    ...pinnedOptions.filter((o) => !options.includes(o)),
  ];

  return (
    <div className="fm-combo" ref={wrapRef}>
      <button
        type="button"
        className="fm-input fm-combo-trigger"
        data-testid={testId}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => {
          setOpen((v) => !v);
          setQuery("");
        }}
      >
        <span className={value ? "fm-combo-value" : "fm-combo-placeholder"}>
          {value || t(placeholder)}
        </span>
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M3 6l5 5 5-5"
            stroke="#C5A059"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div className="fm-combo-menu">
          <input
            autoFocus
            type="text"
            className="fm-combo-search"
            placeholder={t("Type to search…")}
            value={query}
            data-testid={`${testId}-search`}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
          />
          <ul className="fm-combo-list" role="listbox">
            <li
              role="option"
              aria-selected={!value}
              className={`fm-combo-option${!value ? " is-selected" : ""}`}
              data-testid={`${testId}-any`}
              onClick={() => {
                onChange("");
                setOpen(false);
              }}
            >
              {t(placeholder)}
            </li>
            {filtered.map((o) => (
              <li
                key={o}
                role="option"
                aria-selected={value === o}
                className={`fm-combo-option${value === o ? " is-selected" : ""}`}
                data-testid={`${testId}-option-${o.replace(/\s+/g, "-").toLowerCase()}`}
                onClick={() => {
                  onChange(o);
                  setOpen(false);
                }}
              >
                {o}
              </li>
            ))}
            {filtered.length === 0 && (
              <li className="fm-combo-empty">{t("No matches found")}</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
